export default __webpack_public_path__ + "static/media/javascript-svg.197036f5.png";